<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="mainBody">
    <div class="dmv-search-results inner-home">
        <div class="container">
            <div class="row no-margin">
                <div class="col-6 col-sm-2 mt-4"><a><button class="btn btn-primary btn-back top-back-button" (click)="back()"><i
                                class="fa fa-chevron-left text-left"></i> Back</button></a></div>
                <div class="col-12 col-sm-8 mt-4">
                    <div id="searchResu">Select Payment Method</div>
                    <p id="addthereco"><span>&nbsp;</span></p>
                </div>
                <div class="col-6 col-sm-2 icon-cart mt-4">

                </div>
                <div class="col-12 alert alert-danger" role="alert" *ngIf="errorMessage"  > &nbsp;<span [innerHTML]="errorMessage"></span></div>
                          
                <form autocomplete="off" class="w100 text-left mb-b" [formGroup]="paymentMethodForm">
                    <div class="row">
                    <div class="col-12 col-sm-12 col-md-8 m-auto">
                        
                    <div class="row no-margin">
                        <!-- <div class="col-12 alert-danger" role="alert"> Please correct fields in error. </div>
                        <div class="col-12 asteriskMessage"> *Fields marked with an asterisk are required </div> -->
                        <div class="col-12 col-sm-12 mb-4">
                            <div class="select-wrapper-3 monthpicker m-auto">
                               

                            <select
                                class="form-control"  (click)="globalService.selectChange($event)" (keydown)="globalService.selectChangeByKey($event)" (change)="globalService.setDownIcon($event)"  (blur)="globalService.setDownIcon($event)"  formControlName="paymentMethod"  [ngClass]="{ 'is-invalid': submitted && f.paymentMethod.errors }">
                                
                                <option value="">Select a payment method</option>
                                <option *ngFor='let paymentDevice of paymentDevices'
                                [value]="paymentDevice.fundingToken">
                                {{paymentDevice?.displayName}}
                              </option>
                              <option value="NEW_PAYMENT_METHOD" >Use a new payment method </option>
                            </select>
                            <div class="invalid-feedback">Please select a payment method</div>
                           
                        </div>
                        </div>
                      
                       
                       
                     
                        
                    </div>
                </div>
            </div>

                   
                </form>
            </div>

            <div class="container m-auto text-center"><a><button class="btn btn-primary btn-back" (click)="cancel()"><i class="fa fa-chevron-left text-left"></i> Back</button></a><a><button
                        class="btn btn-primary  btn-continue m-auto" (click)="submit()">Continue <i  class="fa fa-chevron-right text-right"></i></button></a></div>
        </div>
    </div>
</div>